import React from 'react';
import { Checkbox } from '@brighterion/br-ui';
import { Column } from 'react-table';
import { useGetColumnConfig } from 'Components/Table/utils';
import { Field, FieldProps } from 'formik';
import { countBy, isEmpty } from 'lodash';
import { RoleService } from 'Services';

const useGetTenantGroupTenantsColumns = () => {
    const { getColConfig } = useGetColumnConfig<TenantGroupTenantsTableColumns>();
    const columns: Column<TenantGroupTenantsTableColumns>[] = [
        {
            accessor: 'tenant',
            Header: 'Tenant ID',
            dataType: 'text',
            width: 20
        },
        {
            accessor: 'tenantName',
            Header: 'Tenant Name',
            width: 40,
            dataType: 'text'
        },
        {
            accessor: 'description',
            Header: 'Description',
            dataType: 'text'
        }
    ];

    if (RoleService.hasTenantGroupWriteAccess) {
        columns.unshift({
            Header: () => {
                return (
                    <Field name='rows'>
                        {({ field, form }: FieldProps) => {
                            return (
                                <Checkbox
                                    checked={form.values.headerCheckboxSelected && !isEmpty(field.value)}
                                    onChange={async () => {
                                        if (form.values.headerCheckboxSelected) {
                                            form.resetForm();
                                        } else {
                                            const rows: Column<TenantGroupTenantsTableColumns>[] = field.value;
                                            rows.forEach(async (_row, index) =>
                                                form.setFieldValue(`${field.name}[${index}].isSelected`, true)
                                            );
                                        }
                                        form.setFieldValue(
                                            'headerCheckboxSelected',
                                            !form.values.headerCheckboxSelected
                                        );
                                    }}
                                />
                            );
                        }}
                    </Field>
                );
            },
            id: 'checkbox',
            accessor: 'tenant',
            disableSortBy: true,
            width: 2,
            renderType: 'checkbox',
            Cell: ({ row }) => {
                return (
                    <Field name={`rows[${row.id}].isSelected`}>
                        {({ field, form }: FieldProps) => {
                            const numOfSelectedTenants = countBy(form.values.rows, (tr) => tr.isSelected).true;

                            return (
                                <Checkbox
                                    checked={field.value}
                                    onChange={(e) => {
                                        form.setFieldValue(field.name, e.target.checked);
                                        // if the last selected teannt is unchecked, uncheck the header checkbox
                                        if (numOfSelectedTenants === 1 && !e.target.checked) {
                                            form.setFieldValue('headerCheckboxSelected', false);
                                        }
                                    }}
                                />
                            );
                        }}
                    </Field>
                );
            }
        });
    }

    return columns.map(getColConfig);
};

export default useGetTenantGroupTenantsColumns;
